import { AppState } from '../../types';

export const selectNotificationsList = (state: AppState) => state.notifications.list;
